import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
if (process.env.VUE_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_SENTRY_DSN,
    integrations: [
      new VueIntegration({ Vue, attachProps: true, logErrors: true }),
    ],
  })
} else {
  console.log('Sentry DSN is not provided. Sentry integration init skipped')
}
